module.exports = __webpack_public_path__ + "static/media/YourAccount.6b8b0971.svg";